//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { uid } from "quasar";
import { required } from "vuelidate/lib/validators";
import rangy from "rangy";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";
import defaultAvatar from "@/assets/images/user.svg";
import FroalaNotifications from "@/components/DocumentEditor/Froala/FroalaNotifications.vue";
import { formatDataModelVar } from "@/components/DocumentEditor/Froala/DatamodelTable";

export default {
    components: {
        AQModal,
        AQBadge,
        AQInput,
        AQDropdown,
        AQToggle,
        AQAvatar,
        AQDialog,
        AQListBtn,
        FroalaNotifications,
        variablesCard: () => import(/* webpackChunkName: "variablesCard" */ "@/components/Diagrams/variables-card.vue")
    },
    props: {
        elementIndex: {
            type: Number
        },
        value: Object,
        showTrigger: {
            type: Boolean,
            default: false
        },
        fromConnector: Boolean,
        readonly: {
            type: Boolean,
            default: false
        },
        fromLevel: {
            type: Boolean
        },
        fromExpose: {
            type: Boolean,
            default: false
        },
        fromBehavior: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const vm = this;

        return {
            badgeType: "USR",
            norificationLoaded: false,
            defaultTriggerEvent: "",
            dataModelFilter: {
                showOnlyType: {
                    Attachment: true
                }
            },
            modalOpened: true,
            formatTime: "",
            formatRec: "",
            showSave: { color: "positive" },
            hasHeaderActions: true,
            headerActionsModel: [{
                label: this.$t("diagrams.components.setLevels.delete"),
                value: "deleteNotification"
            }],
            toolbarData: [
                ["bold", "italic", "strike", "underline"],
                ["token", "hr", "link", "custom_btn"],
                ["print", "fullscreen"]
            ],
            saveDisabled: true,
            errorName: false,
            errorTrigger: false,
            errorTaskEvent: false,
            finishedLoading: false,
            instanceName: null,
            showVariables: false,
            variablesFor: "",
            activeTab: "EMAIL",
            copyNotifInfo: {},
            notification: null,
            detailExtraUsersTo: false,
            detailExtraUsersCc: false,
            detailExtraUsersBcc: false,
            timeframeError: false,
            timeRecError: false,
            noNullValues: false,
            noNullValRec: false,
            afterSubjectButton: [{
                icon: "",
                handler() {
                    vm.variablesFor = "subject";
                    vm.showVariables = true;
                }
            }],
            defaultAvatar,
            selectedTemplate: null,
            messageObject: {
                message: "",
                id: null,
                subject: "",
                attachments: [],
                name: "",
                rules: [],
                blockCounter: 0,
                repeatableParameters: [],
                repeatableBlockCounter: 0
            },
            copyMessageObject: {},
            caretPosition: 0,
            repeatDisabled: false,
            lastUserSelection: null,
            typeRecipients: "",
            repeat: false,
            timeframeDisabled: false,
            taskEventOptions: [],
            resetTaskEvent: false,
            warningDialog: false,
            whenOptions: [
                {
                    label: this.$t("diagrams.components.notifications.after"),
                    value: "after"
                },
                {
                    label: this.$t("diagrams.components.notifications.before"),
                    value: "before"
                },
                {
                    label: this.$t("diagrams.components.notifications.on"),
                    value: "on"
                }
            ],
            allTaskEventOptions: [
                {
                    label: this.$t("diagrams.components.notifications.expiration"),
                    value: "expiration"
                },
                {
                    label: this.$t("diagrams.components.notifications.deadline"),
                    value: "deadline"
                },
                {
                    label: this.$t("diagrams.components.notifications.creation"),
                    value: "creation"
                },
                {
                    label: this.$t("diagrams.components.notifications.completion"),
                    value: "completion"
                }
            ],
            documentEmail: {
                id: uid(),
                processDefinitionId: "",
                template: "",
                rules: [],
                repeatableParameters: [],
                blockCounter: 0,
                repeatableBlockCounter: 0
            },
            documentSMS: {
                id: uid(),
                processDefinitionId: "",
                template: ""
            },
            updateComponent: 0,
            hideListBtn: ["edit", "more", "copy", "download"]
        };
    },
    validations: {
        notification: {
            name: {
                required
            },
            to: {
                hasValue(to) {
                    return to.user.length || to.role.length || to.model.length || to.variable.length
                    || to.freeText.length || (to.dataTextList ? to.dataTextList.length : false);
                }
            },
            trigger: {
                required
            }
        },
        messageObject: {
            message: {
                required
            },
            subject: {
                required
            }
        }
    },
    computed: {
        ...mapGetters("main", ["getCurrentApplicationId"]),
        ...mapGetters("diagrams", ["selectedPluginConfigData", "diagramConfigData", "modelForProcessDefinition"]),
        ...mapGetters("admin", ["roleList", "userList", "getAllMembersData"]),
        mode() {
            let typeMode;
            if (this.variablesFor === "att") {
                typeMode = "att";
            } else {
                typeMode = ["to", "cc", "bcc"].includes(this.variablesFor) ? "d" : "b";
            }

            return typeMode;
        },
        hasDone() {
            return {
                label: this.$t("generic.done"),
                disabled: ((this.readonly || this.showSave) && this.saveDisabled)
            };
        },
        computedTriggerForInfoBox() {
            return typeof this.notification.trigger === "object" ? this.notification.trigger[0].value !== "on" : this.notification.trigger !== "on";
        },
        computedTriggerVal() {
            let triggerToCheck;
            let formatTriggerFromBE;

            if (typeof this.notification.trigger === "object") {
                this.whenOptions.forEach(data => {
                    if (this.notification.trigger[0].value === data.value) {
                        formatTriggerFromBE = data.value;
                        triggerToCheck = data.label.toLowerCase();
                    }
                });
            } else {
                this.whenOptions.forEach(data => {
                    if (this.notification.trigger === data.value) {
                        formatTriggerFromBE = data.value;
                        triggerToCheck = data.label.toLowerCase();
                    }
                });
            }
            return (formatTriggerFromBE !== "on") ? triggerToCheck : (triggerToCheck.charAt(0).toUpperCase() + triggerToCheck.slice(1));
        },
        computedEventVal() {
            let elToReturn;
            if (typeof this.notification.taskEvent === "object" && this.notification.taskEvent.length) {
                this.allTaskEventOptions.forEach(data => {
                    if (this.notification.taskEvent[0].value === data.value) {
                        elToReturn = data.label.toLowerCase();
                    }
                });
            } else if (typeof this.notification.taskEvent === "string") {
                this.allTaskEventOptions.forEach(data => {
                    if (this.notification.taskEvent === data.value) {
                        elToReturn = data.label.toLowerCase();
                    }
                });
            } else {
                elToReturn = "";
            }
            return elToReturn;
        },
        triggerComp() {
            let elToReturn;
            if (typeof this.notification.trigger === "string") {
                elToReturn = this.notification.trigger.toLowerCase();
            } else if (this.notification.trigger && this.notification.trigger.length) {
                elToReturn = this.notification.trigger[0].value;
            }
            return elToReturn;
        },
        returnTitle() {
            return this.fromConnector
                ? this.$t("diagrams.components.notifications.notifications")
                : `${this.elementIndex + 1}.${this.selectedPluginConfigData.label}/${this.$t("diagrams.components.notifications.notifications")}`;
        },
        detailedNotificationToList() {
            const users = [];

            if (this.notification.to.user.length) {
                this.getUserInfo(this.notification.to.user, users);
            }

            if (this.notification.to.role.length) {
                this.getRoleInfo(this.notification.to.role, users);
            }

            this.notification.to.model.forEach(el => {
                users.push({
                    type: "MOD",
                    id: el,
                    name: el,
                    color: "warning"
                });
            });

            this.notification.to.variable.forEach(el => {
                users.push({
                    type: "VAR",
                    id: el,
                    name: el,
                    color: "secondary"
                });
            });

            this.notification.to.freeText.forEach((el, i) => {
                const val = this.activeTab === "EMAIL" ? el.email1 : el.phone1;

                if (val) {
                    users.push({
                        type: "TXT",
                        id: `${i}_${val}`,
                        name: val,
                        color: "secondary"
                    });
                }
            });

            return users;
        },
        detailedNotificationCcList() {
            const vm = this;
            const users = [];

            if (vm.notification.cc.user.length) {
                this.getUserInfo(vm.notification.cc.user, users);
            }

            if (vm.notification.cc.role.length) {
                this.getRoleInfo(vm.notification.cc.role, users);
            }

            vm.notification.cc.model.forEach(el => {
                users.push({
                    type: "MOD",
                    id: el,
                    name: el,
                    color: "warning"
                });
            });

            vm.notification.cc.variable.forEach(el => {
                users.push({
                    type: "VAR",
                    id: el,
                    name: el,
                    color: "secondary"
                });
            });

            vm.notification.cc.freeText.forEach((el, i) => {
                const val = vm.activeTab === "EMAIL" ? el.email1 : el.phone1;

                if (val) {
                    users.push({
                        type: "TXT",
                        id: `${i}_${val}`,
                        name: val,
                        color: "secondary"
                    });
                }
            });

            return users;
        },
        detailedNotificationBccList() {
            const vm = this;
            const users = [];

            if (vm.notification.bcc && vm.notification.bcc.user.length) {
                this.getUserInfo(vm.notification.bcc.user, users);
            }

            if (vm.notification.bcc && vm.notification.bcc.role.length) {
                this.getRoleInfo(vm.notification.bcc.role, users);
            }
            if (vm.notification.bcc) {
                vm.notification.bcc.model.forEach(el => {
                    users.push({
                        type: "MOD",
                        id: el,
                        name: el,
                        color: "warning"
                    });
                });

                vm.notification.bcc.variable.forEach(el => {
                    users.push({
                        type: "VAR",
                        id: el,
                        name: el,
                        color: "secondary"
                    });
                });

                vm.notification.bcc.freeText.forEach((el, i) => {
                    const val = vm.activeTab === "EMAIL" ? el.email1 : el.phone1;

                    if (val) {
                        users.push({
                            type: "TXT",
                            id: `${i}_${val}`,
                            name: val,
                            color: "secondary"
                        });
                    }
                });
            }

            return users;
        },
        extraUsersToList() {
            return this.detailedNotificationToList.filter((el, i) => {
                if (i < 2) {
                    return false;
                }
                return el;
            });
        },
        extraUsersCcList() {
            return this.detailedNotificationCcList.filter((el, i) => {
                if (i < 2) {
                    return false;
                }
                return el;
            });
        },
        extraUsersBccList() {
            return this.detailedNotificationBccList.filter((el, i) => {
                if (i < 2) {
                    return false;
                }
                return el;
            });
        },
        emailTemplates() {
            return this.diagramConfigData.messages.filter(el => {
                if (el.type === "EMAIL") {
                    return el;
                }

                return false;
            });
        },
        smsTemplates() {
            return this.diagramConfigData.messages.filter(el => {
                if (el.type === "SMS") {
                    return el;
                }

                return false;
            });
        },
        computedVariablesCardModel: {
            get() {
                if (this.variablesFor === "att") {
                    return {
                        model: this.messageObject.attachments || []
                    };
                }

                return this.notification[this.variablesFor];
            },
            set(v) {
                if (this.variablesFor === "att") {
                    this.messageObject.attachments = v.model;
                } else {
                    const notif = this.notification[this.variablesFor];
                    const arrayRoles = [];
                    for (let i = 0; i < notif.role.length; i++) {
                        const found = v.role.find(el => el === notif.role[i]);
                        if (!found) {
                            const found2 = this.getAllMembersData.parent.find(elem => elem.id === notif.role[i]);
                            if (!found2) {
                                arrayRoles.push(notif.role[i]);
                            }
                        }
                    }
                    const arrayUsers = [];
                    for (let i = 0; i < notif.user.length; i++) {
                        const found = v.user.find(el => el === notif.user[i]);
                        if (!found) {
                            const found2 = this.getAllMembersData.parent.find(elem => elem.id === notif.user[i]);
                            if (!found2) {
                                arrayUsers.push(notif.user[i]);
                            }
                        }
                    }
                    notif.role = v.role.concat(arrayRoles);
                    notif.user = v.user.concat(arrayUsers);
                    notif.dataTextList = v.dataTextList;
                    notif.freeText = v.freeText;
                    notif.model = v.model;
                    notif.variable = v.variable;
                }
            }
        },
        timeframeErrorLabel() {
            let errorMsg = "";
            if (!this.notification.timeFrame) {
                errorMsg = this.$t("diagrams.components.notifications.mandatory");
            } else if (this.noNullValues && this.timeframeError) {
                errorMsg = this.$t("diagrams.components.notifications.noNullValues");
            } else if (this.timeframeError) {
                errorMsg = this.$t("diagrams.components.notifications.validFormat");
            }
            return errorMsg;
        },
        recurrenceErrorLabel() {
            let errorMsg = "";
            if (!this.notification.recurrence && this.repeat) {
                errorMsg = this.$t("diagrams.components.notifications.mandatory");
            } else if (this.noNullValRec && this.timeRecError) {
                errorMsg = this.$t("diagrams.components.notifications.noNullValues");
            } else if (this.timeRecError) {
                errorMsg = this.$t("diagrams.components.notifications.validFormat");
            }
            return errorMsg;
        },
        showMessage() {
            let foundError = true;
            if (this.repeat && !this.notification.recurrence) {
                foundError = false;
            }
            return this.notification.timeFrame && this.notification.trigger && this.notification.trigger.length
                        && this.notification.taskEvent && this.notification.taskEvent.length
                        && !this.noNullValues && !this.noNullValRec && !this.timeRecError && !this.timeframeError && foundError;
        }
    },
    watch: {
        activeTab(v) {
            this.notification.notificationType = v;
        },
        notification: {
            handler() {
                if (this.finishedLoading) {
                    this.saveDisabled = false;
                }
            },
            deep: true,
            immediate: false
        },
        documentSMS: {
            handler() {
                if (this.finishedLoading) {
                    this.saveDisabled = false;
                }
            },
            deep: true,
            immediate: true
        },
        documentEmail: {
            handler() {
                if (this.finishedLoading) {
                    this.saveDisabled = false;
                }
            },
            deep: true,
            immediate: true
        },
        messageObject: {
            handler() {
                if (this.finishedLoading) {
                    this.saveDisabled = false;
                }
            },
            deep: true,
            immediate: true
        },
        variablesFor(v) {
            if (this.$refs.variablesCard) {
                this.$refs.variablesCard.localCheckedValues = null;
            }
            if (v === "att") {
                this.dataModelFilter = {
                    showOnlyType: {
                        Attachment: true
                    }
                };
            } else {
                this.dataModelFilter = null;
            }
        },
        value: {
            handler(newVal) {
                this.notification = newVal ? JSON.parse(JSON.stringify(newVal)) : {
                    id: uid(),
                    name: "",
                    trigger: "",
                    notificationType: "EMAIL",
                    message: null,
                    to: {
                        user: [],
                        role: [],
                        model: [],
                        variable: [],
                        freeText: []
                    },
                    cc: {
                        user: [],
                        role: [],
                        model: [],
                        variable: [],
                        freeText: []
                    },
                    bcc: {
                        user: [],
                        role: [],
                        model: [],
                        variable: [],
                        freeText: []
                    },
                    attachments: [],
                    taskEvent: "",
                    timeFrame: "",
                    recurrence: ""
                };
                if (!this.notification.bcc) {
                    this.notification.bcc = {
                        user: [],
                        role: [],
                        model: [],
                        variable: [],
                        freeText: []
                    };
                }
                if (!this.showTrigger) {
                    this.notification.trigger = "after";
                }

                this.activeTab = this.notification.notificationType;
            },
            immediate: true,
            deep: true
        },
        "notification.message": {
            handler(uuid) {
                if (typeof uuid === "string") {
                    this.messageObject = JSON.parse(JSON.stringify(this.diagramConfigData.messages.filter(el => {
                        if (el.id === uuid) {
                            return el;
                        }

                        return false;
                    })[0]));

                    this.setBody();
                }
            },
            immediate: true
        },
        selectedTemplate(v) {
            if (v) {
                this.messageObject = { ...v, id: null };
                this.setBody();
            }
        },
        "notification.trigger": {
            handler(val) {
                if ((val && val.length && val[0].value === "on") || val === "on") {
                    if (val[0] && val[0].value) {
                        if (this.fromLevel || this.fromExpose) {
                            this.taskEventOptions = this.allTaskEventOptions.filter(elem => elem.value !== "deadline");
                        } else {
                            this.taskEventOptions = this.allTaskEventOptions;
                        }
                    }
                    this.notification.timeFrame = "0d";
                    this.formatTime = "";
                    this.timeframeDisabled = true;
                    this.timeframeError = false;
                    this.formatTimeframe(this.notification.timeFrame, false);
                    if (this.notification.taskEvent && typeof this.notification.taskEvent === "object" && Object.keys(this.notification.taskEvent).length) {
                        this.repeatDisabled = (val[0].value === "on" || val === "on")
                        && !!this.notification.taskEvent && ["expiration", "completion"].includes(this.notification.taskEvent[0].value);
                        if (this.repeatDisabled) {
                            this.repeat = false;
                            this.formatRec = "";
                        }
                    } else if (this.notification.taskEvent && typeof this.notification.taskEvent === "string") {
                        this.repeatDisabled = (val[0].value === "on" || val === "on") && !!this.notification.taskEvent
                            && ["expiration", "completion"].includes(this.notification.taskEvent);
                        if (this.repeatDisabled) {
                            this.repeat = false;
                            this.formatRec = "";
                        }
                    }
                } else if ((val && val.length && val[0].value === "before") || val === "before") {
                    if (val[0] && val[0].value) {
                        this.taskEventOptions = this.allTaskEventOptions.filter(elem => (this.fromLevel || this.fromExpose ? elem.value === "expiration"
                            : (elem.value === "expiration" || elem.value === "deadline")));
                    }
                    if (this.timeframeDisabled) {
                        this.timeframeDisabled = false;
                        this.notification.timeFrame = "";
                    }
                } else if ((val && val.length && val[0].value === "after") || val === "after") {
                    if (this.timeframeDisabled) {
                        this.timeframeDisabled = false;
                        this.notification.timeFrame = "";
                    }
                    this.taskEventOptions = this.allTaskEventOptions.filter(elem => elem.value === "deadline");
                }
            }
        },
        "notification.taskEvent": {
            handler(val) {
                this.repeatDisabled = val.length > 0 && ["expiration", "completion"].includes(val[0].value) && !!this.notification.trigger
                && (typeof this.notification.trigger === "object"
                    ? (this.notification.trigger[0] && this.notification.trigger[0].value === "on") : this.notification.trigger === "on");
                if (this.repeatDisabled) {
                    this.repeat = false;
                    this.formatRec = "";
                }
            }
        },
        repeat: {
            handler(val) {
                if (!val) {
                    this.notification.recurrence = "";
                    this.timeRecError = false;
                }
            }
        }
    },

    created() {
        this.$root.$on("enableDoneNotif", () => {
            this.saveDisabled = false;
        });
        if (this.notification.taskEvent) {
            this.defaultTriggerEvent = this.notification.taskEvent;
        }
        if (!this.notification.taskEvent && this.notification.trigger) {
            if (this.fromLevel || this.fromExpose) {
                this.taskEventOptions = this.allTaskEventOptions.filter(elem => elem.value !== "deadline");
            } else {
                this.taskEventOptions = this.allTaskEventOptions;
            }
            if (this.notification.trigger === "before") {
                this.defaultTriggerEvent = "creation";
            } else {
                this.defaultTriggerEvent = "completion";
            }
            this.notification.trigger = "on";
            this.notification.timeFrame = "0d";
            this.formatTime = "";
            this.timeframeDisabled = true;
            this.timeframeError = false;
        } else {
            const noAfter = elem => elem.value !== "after";
            if (this.notification.trigger) {
                if (this.notification.trigger === "before") {
                    if (this.fromLevel || this.fromExpose) {
                        this.taskEventOptions = this.allTaskEventOptions.filter(elem => elem.value === "expiration");
                        this.whenOptions = this.whenOptions.filter(noAfter);
                    } else {
                        this.taskEventOptions = this.allTaskEventOptions.filter(elem => elem.value === "expiration" || elem.value === "deadline");
                    }
                } else if (!this.fromLevel && !this.fromExpose && this.notification.trigger === "after") {
                    this.taskEventOptions = this.allTaskEventOptions.filter(elem => elem.value === "deadline");
                } else if (this.fromLevel || this.fromExpose) {
                    this.taskEventOptions = this.allTaskEventOptions.filter(elem => elem.value !== "deadline");
                    this.whenOptions = this.whenOptions.filter(noAfter);
                } else {
                    this.taskEventOptions = this.allTaskEventOptions;
                }
            } else if (this.fromLevel || this.fromExpose) {
                this.taskEventOptions = this.allTaskEventOptions.filter(elem => elem.value !== "deadline");
                this.whenOptions = this.whenOptions.filter(elem => elem.value !== "after");
            } else {
                this.taskEventOptions = this.allTaskEventOptions;
            }
            this.notification.trigger = this.notification.trigger.toLowerCase();
            if (this.notification.trigger === "on" && (this.notification.taskEvent === "expiration" || this.notification.taskEvent === "completion")) {
                this.repeat = false;
                this.repeatDisabled = true;
                this.formatRec = "";
            }
            if (this.notification.timeFrame) {
                this.notification.timeFrame = this.loadDateFormat(this.notification.timeFrame);
                this.formatTimeframe(this.notification.timeFrame, false);
            }
            if (this.notification.recurrence) {
                this.repeat = true;
                this.notification.recurrence = this.loadDateFormat(this.notification.recurrence);
                this.formatTimeframe(false, this.notification.recurrence);
            }
        }
        this.documentEmail.processDefinitionId = this.getCurrentApplicationId;
        this.documentSMS.processDefinitionId = this.getCurrentApplicationId;
        this.$store.dispatch("diagrams/getModelForProcessDefinition").then(() => {
            this.finishedLoading = true;
        });
        const copyOfNotif = { ...this.notification };
        if (this.notification.trigger) {
            copyOfNotif.taskEvent = [{
                label: this.notification.taskEvent.charAt(0).toUpperCase() + this.notification.taskEvent.slice(1),
                value: this.notification.taskEvent
            }];
            copyOfNotif.trigger = [{
                label: this.notification.trigger.charAt(0).toUpperCase() + this.notification.trigger.slice(1),
                value: this.notification.trigger
            }];
        }
        this.copyNotifInfo = { ...copyOfNotif };
        this.copyMessageObject = { ...this.messageObject };
        if (!this.copyMessageObject.type) {
            this.copyMessageObject.type = "EMAIL";
        }
    },
    mounted() {
        this.norificationLoaded = true;
        window.rangy = rangy;
        if (!this.fromBehavior) {
            this.$store.dispatch("admin/getRoleList");
            this.$store.dispatch("admin/getUsersList");
        }
    },
    beforeDestroy() {
        this.$root.$off("enableDoneNotif");
    },
    methods: {
        onTriggerInput() {
            this.errorTrigger = false;
            if (this.norificationLoaded) {
                this.resetTaskEvent = true;
            } else {
                this.norificationLoaded = false;
            }
        },
        addDataTable() {
            this.saveDisabled = false;
        },
        selectRecipients(type) {
            if (!this.readonly) {
                this.variablesFor = type;
                this.showVariables = true;
                this.typeRecipients = type;
                this.updateComponent++;
            }
        },
        addItemOpenVariables(variablesFor) {
            if (!this.readonly) {
                this.variablesFor = variablesFor;
                this.showVariables = true;
                if (variablesFor === "att") {
                    this.updateComponent++;
                }
            }
        },
        formatTimeframe(timeframe, timeRec) {
            let dayTime;
            let hoursTime;
            let minTime;
            let timeFrameCopy;
            let format;
            const daysLabel = this.$t("diagrams.components.notifications.daysLabel");
            const hoursLabel = this.$t("diagrams.components.notifications.hoursLabel");
            const minsLabel = this.$t("diagrams.components.notifications.minsLabel");
            const andlabel = this.$t("diagrams.components.notifications.andLabel");
            const timeToParse = timeframe || timeRec;
            let passTheParser = true;
            const triggerToCheck = typeof this.notification.trigger === "object" ? this.notification.trigger[0].value : this.notification.trigger;
            if (timeframe && triggerToCheck === "on") {
                passTheParser = false;
            }
            if (timeToParse && passTheParser) {
                timeFrameCopy = timeToParse.includes(" ") ? timeToParse.split(" ") : timeToParse;
                if (typeof timeFrameCopy === "object") {
                    for (let i = 0; i < timeFrameCopy.length; i++) {
                        if (timeFrameCopy[i].includes("d")) {
                            dayTime = timeFrameCopy[i].replace(/d/gi, "");
                        }
                        if (timeFrameCopy[i].includes("h")) {
                            hoursTime = timeFrameCopy[i].replace(/h/gi, "");
                        }
                        if (timeFrameCopy[i].includes("m")) {
                            minTime = timeFrameCopy[i].replace(/m/gi, "");
                        }
                    }
                } else if (timeFrameCopy.includes("d")) {
                    dayTime = timeFrameCopy.replace(/d/gi, "");
                } else if (timeFrameCopy.includes("h")) {
                    hoursTime = timeFrameCopy.replace(/h/gi, "");
                } else if (timeFrameCopy.includes("m")) {
                    minTime = timeFrameCopy.replace(/m/gi, "");
                }
            }
            if (timeframe
                    && ((typeof this.notification.trigger === "object" ? this.notification.trigger[0].value === "after" : this.notification.trigger === "after")
                || (typeof this.notification.trigger === "object"
                    ? this.notification.trigger[0].value === "before" : this.notification.trigger === "before"))) {
                const checkTimeFrame = timeframe.replace(/ /g, "").replace(/d|h|m|0/gi, "");
                if (!checkTimeFrame) {
                    this.noNullValues = true;
                    this.timeframeError = true;
                }
            }

            if (timeRec) {
                const checkTimeFrame = timeRec.replace(/ /g, "").replace(/d|h|m|0/gi, "");
                if (!checkTimeFrame) {
                    this.noNullValRec = true;
                    this.timeRecError = true;
                }
            }

            if (!this.noNullValues && !this.noNullValRec) {
                format = null;

                if (dayTime) {
                    if (hoursTime) {
                        if (minTime) {
                            format = `${dayTime + daysLabel}, ${hoursTime}${hoursLabel}${andlabel}${minTime}${minsLabel}`;
                        } else {
                            format = dayTime + daysLabel + andlabel + hoursTime + hoursLabel;
                        }
                    } else if (minTime) {
                        format = dayTime + daysLabel + andlabel + minTime + minsLabel;
                    } else {
                        format = dayTime + daysLabel;
                    }
                } else if (hoursTime) {
                    if (minTime) {
                        format = hoursTime + hoursLabel + andlabel + minTime + minsLabel;
                    } else {
                        format = hoursTime + hoursLabel;
                    }
                } else if (minTime) {
                    format = minTime + minsLabel;
                }

                this[timeframe ? "formatTime" : "formatRec"] = format;
            }

            return timeframe ? this.formatTime : this.formatRec;
        },
        checkTimeframe() {
            const validatePattern = /^(?:\d+[dD](?: {1}|$))?(?:\d+[hH](?: {1}|$))?(?:\d+[mM](?: {1}|$))?$/;
            if (this.notification.timeFrame) {
                if (validatePattern.exec(this.notification.timeFrame)) {
                    this.formatTimeframe(this.notification.timeFrame, false);
                } else {
                    this.timeframeError = true;
                }
            } else {
                this.formatTime = "";
            }
        },
        checkRecurrence() {
            const validatePattern = /^(?:\d+[dD](?: {1}|$))?(?:\d+[hH](?: {1}|$))?(?:\d+[mM](?: {1}|$))?$/;
            if (this.notification.recurrence) {
                if (validatePattern.exec(this.notification.recurrence)) {
                    this.formatTimeframe(false, this.notification.recurrence);
                } else {
                    this.timeRecError = true;
                }
            } else {
                this.formatRec = "";
            }
        },
        showDetailsNotifToListItem(item, i, ccRecipients, bccRecipients) {
            let showItem = false;
            if (item.type === "USR" || item.type === "GRU" || item.active
            || item.type === "VAR" || item.type === "MOD" || item.type === "TXT") {
                if (ccRecipients) {
                    showItem = (this.detailExtraUsersCc || i < 2);
                } else if (bccRecipients) {
                    showItem = (this.detailExtraUsersBcc || i < 2);
                } else {
                    showItem = (this.detailExtraUsersTo || i < 2);
                }
            }
            return showItem;
        },
        afterHide() {
            this.$emit("closeDialog", false);
        },
        setItemType(item) {
            let type;
            if (item.type === "GRU") {
                if (item.sourceType === "AD" || item.systemType === "EXTERNAL") {
                    type = "externalGroup";
                } else if (item.systemType === "APPLICATION") {
                    type = "applicationSpecific";
                } else {
                    type = "platform";
                }
            } else if (item.type === "USR") {
                if (item.systemType === "TOAUTHUSR") {
                    type = "systemExternalUser";
                } else if (item.systemType === "TSYS") {
                    type = "systemInternalUser";
                } else {
                    type = (item.sourceType === "AD" || item.systemType === "TSAMLUSR" || item.systemType === "TOPENIDUSR") ? "externalUser" : "userPlatform";
                }
            }
            return type;
        },
        setImage(user) {
            return user && (user.avatar || user.avatarPath) ? `/identity/tenants/users/image/${user.id}/s` : null;
        },
        action(action) {
            if (action === "primary") {
                this.$root.$emit("forceSaveEditor");
                if (this.errorName || this.errorTrigger || this.timeRecError || this.errorTaskEvent || this.timeframeError) {
                    return false;
                }
                if (this.$v.notification.name.$invalid) {
                    this.errorName = true;
                    return false;
                }

                if (this.showTrigger && (!this.notification.trigger || !this.notification.trigger.length)) {
                    this.errorTrigger = true;
                    return false;
                }

                if (!this.notification.recurrence && this.repeat) {
                    this.timeRecError = true;
                    return false;
                }

                if (this.showTrigger && (!this.notification.taskEvent || !this.notification.taskEvent.length)) {
                    this.errorTaskEvent = true;
                    return false;
                }

                if (!this.notification.timeFrame) {
                    this.timeframeError = true;
                    return false;
                }

                if (this.$v.notification.to.$invalid) {
                    this.$toast.showNotify({
                        type: "warning",
                        message: this.$t("diagrams.components.notifications.notificationTargetRequired")
                    });
                    return false;
                }

                if (this.activeTab === "SMS") {
                    if (!this.documentSMS.template) {
                        this.$toast.showNotify({
                            type: "warning",
                            message: this.$t("diagrams.components.notifications.messageRequired")
                        });
                        return false;
                    }
                    this.messageObject.message = `<html>${this.documentSMS.template}</html>`;
                }

                if (this.activeTab === "EMAIL") {
                    if (this.$v.messageObject.subject.$invalid) {
                        this.$toast.showNotify({
                            type: "warning",
                            message: this.$t("diagrams.components.notifications.subjectRequired")
                        });
                        return false;
                    }

                    if (!this.documentEmail.template) {
                        this.$toast.showNotify({
                            type: "warning",
                            message: this.$t("diagrams.components.notifications.messageRequired")
                        });
                        return false;
                    }
                    const { template, rules, blockCounter, repeatableParameters, repeatableBlockCounter } = this.documentEmail;
                    this.messageObject.message = `<html>${template}</html>`;
                    this.messageObject.rules = rules;
                    this.messageObject.blockCounter = blockCounter;
                    this.messageObject.repeatableParameters = repeatableParameters;
                    this.messageObject.repeatableBlockCounter = repeatableBlockCounter;
                }

                // if no id set it means it's new, else set existing id
                let timeframe; let
                    recurrence;
                let dayTime = "0";
                let hoursTime = "0";
                let minTime = "0";
                let dayRec = "0";
                let hoursRec = "0";
                let minRec = "0";
                if (this.notification.timeFrame) {
                    timeframe = this.notification.timeFrame.split(" ");
                    for (let i = 0; i < timeframe.length; i++) {
                        if (timeframe[i].includes("d")) {
                            dayTime = timeframe[i].replace(/d/gi, "");
                        } else if (timeframe[i].includes("h")) {
                            hoursTime = timeframe[i].replace(/h/gi, "");
                        } else if (timeframe[i].includes("m")) {
                            minTime = timeframe[i].replace(/m/gi, "");
                        }
                    }
                }
                timeframe = `${dayTime};${hoursTime};${minTime}`;

                if (this.notification.recurrence) {
                    recurrence = this.notification.recurrence.split(" ");
                    for (let i = 0; i < recurrence.length; i++) {
                        if (recurrence[i].includes("d")) {
                            dayRec = recurrence[i].replace(/d/gi, "");
                        } else if (recurrence[i].includes("h")) {
                            hoursRec = recurrence[i].replace(/h/gi, "");
                        } else if (recurrence[i].includes("m")) {
                            minRec = recurrence[i].replace(/m/gi, "");
                        }
                    }
                }
                if (dayRec === "0" && hoursRec === "0" && minRec === "0") {
                    recurrence = null;
                } else {
                    recurrence = `${dayRec};${hoursRec};${minRec}`;
                }
                const messageUid = this.messageObject.id || uid();
                this.messageObject.name = this.notification.name;
                this.messageObject.id = messageUid;
                this.messageObject.type = this.activeTab;
                this.$store.commit("diagrams/addMessageToConfig", this.messageObject);
                this.notification.message = messageUid;
                if (this.showTrigger) {
                    this.notification.timeFrame = timeframe;
                    this.notification.recurrence = recurrence;
                    this.notification.taskEvent = typeof this.notification.taskEvent === "object"
                        ? this.notification.taskEvent[0].value : this.notification.taskEvent.toLowerCase();
                    this.notification.trigger = typeof this.notification.trigger === "object"
                        ? this.notification.trigger[0].value : this.notification.trigger.toLowerCase();
                } else {
                    this.notification.trigger = "after";
                    delete this.notification.timeFrame;
                    delete this.notification.recurrence;
                    delete this.notification.taskEvent;
                }
                this.$emit("save", this.notification);
                this.hide();
            } else if (action === this.$t("diagrams.components.setLevels.delete")) {
                if (this.value && this.value.id) {
                    this.$emit("deleteNotification", this.value.id);
                }
                this.hide();
            } else if (action !== "escape") {
                this.messageObject.message = this.activeTab === "EMAIL" ? this.documentEmail.template : this.documentSMS.template;
                if (this.messageObject.message && (!this.messageObject.message.startsWith("<html>") || !this.messageObject.message.endsWith("</html>"))) {
                    this.messageObject.message = `<html>${this.messageObject.message}</html>`;
                }
                this.messageObject.type = this.activeTab;
                if (JSON.stringify(this.copyNotifInfo) !== JSON.stringify(this.notification)
                        || JSON.stringify(this.copyMessageObject) !== JSON.stringify(this.messageObject)) {
                    this.warningDialog = true;
                } else {
                    this.hide();
                }
            }
            return false;
        },
        hide() {
            this.modalOpened = false;
        },
        onFieldClicked(data) {
            let value;
            let newElemment = "";
            newElemment = formatDataModelVar({ formatted: data.field.variable, model: data.field.name, type: data.field.type });

            if (this.variablesFor === "subject") {
                value = this.messageObject[this.variablesFor];

                this.messageObject[this.variablesFor] = `${value.substr(0, this.caretPosition || 0)}
                ${data.field.variable} ${value.substr(this.caretPosition || 0, value.length)}`;
            }
            if (this.variablesFor === "message") {
                this.$root.$emit("sendElToInsert", newElemment);
            }
        },
        getUserInfo(userIdList, detailedList) {
            const foundUsers = [];
            this.userList.forEach(user => {
                if (userIdList.indexOf(user.id) !== -1) {
                    let currentName = user.firstName || "";
                    if (user.lastName) {
                        currentName = `${currentName} ${user.lastName}`;
                    }
                    detailedList.push({
                        avatarPath: user.avatarPath,
                        type: "USR",
                        id: user.id,
                        name: currentName.trim(),
                        color: "positive",
                        systemType: user.type,
                        email: user.username,
                        status: user.status
                    });

                    foundUsers.push(user.id);
                }
            });

            if (foundUsers.length !== userIdList.length) {
                const unknownUsers = userIdList.filter(usrId => foundUsers.indexOf(usrId) === -1);

                unknownUsers.forEach(usrId => {
                    detailedList.push({
                        type: "USR",
                        id: usrId,
                        name: this.$t("generic.notFound", { id: usrId }),
                        color: "positive",
                        email: ""
                    });
                });
            }
        },
        getRoleInfo(roleIdList, detailedList) {
            const foundRoles = [];
            this.roleList.forEach(role => {
                if (roleIdList.includes(role.code) || roleIdList.includes(role.id)) {
                    detailedList.push({
                        active: role.active,
                        type: "GRU",
                        id: role.id,
                        name: role.name,
                        systemType: role.systemType,
                        sourceType: role.sourceType || null,
                        color: "primary"
                    });

                    foundRoles.push(role.code);
                }
            });

            if (foundRoles.length !== roleIdList.length) {
                const unknownRoles = roleIdList.filter(roleId => foundRoles.indexOf(roleId) === -1);

                unknownRoles.forEach(roleId => {
                    detailedList.push({
                        type: "GRU",
                        id: roleId,
                        name: this.$t("generic.notFound", { id: roleId }),
                        color: "primary"
                    });
                });
            }
        },
        deleteRecipient(id, type, list) {
            let userType;

            if (type === "USR") {
                userType = "user";
                this.$root.$emit("deleteMember", id);
            } else if (type === "GRU") {
                userType = "role";
                this.$root.$emit("deleteMember", id);
            } else if (type === "MOD") {
                userType = "model";
            } else if (type === "VAR") {
                userType = "variable";
            } else if (type === "TXT") {
                userType = "freeText";
            }

            this.notification[list][userType].splice(this.notification[list][userType].indexOf(id), 1);
        },
        getCaretPositionForDiv(editableDiv) {
            let caretPos = 0;
            let sel; let
                range;
            if (window.getSelection) {
                sel = window.getSelection();
                if (sel.rangeCount) {
                    range = sel.getRangeAt(0);
                    if (range.commonAncestorContainer.parentNode === editableDiv) {
                        caretPos = range.endOffset;
                    }
                }
            } else if (document.selection && document.selection.createRange) {
                range = document.selection.createRange();
                if (range.parentElement() === editableDiv) {
                    const tempEl = document.createElement("span");
                    editableDiv.insertBefore(tempEl, editableDiv.firstChild);
                    const tempRange = range.duplicate();
                    tempRange.moveToElementText(tempEl);
                    tempRange.setEndPoint("EndToEnd", range);
                    caretPos = tempRange.text.length;
                }
            }
            return caretPos;
        },
        onCaretChange(ev, type) {
            if (type === "message") {
                const selection = rangy.getSelection();

                this.lastUserSelection = selection.saveRanges();
            }

            if (ev.target.nodeName === "DIV") {
                this.caretPosition = this.getCaretPositionForDiv(ev.target);
            } else {
                this.caretPosition = ev.target.selectionStart;
            }

            if (this.showVariables) {
                if (this.variablesFor === "att") {
                    this.updateComponent++;
                }
                this.variablesFor = type;
                if (type === "subject") {
                    setTimeout(() => {
                        this.$refs.subjectInput.$refs.AQInput.focus();
                    }, 0);
                }
            }
        },
        setBody() {
            if (this.notification.notificationType === "SMS") {
                this.documentSMS.template = this.messageObject.message;
            } else {
                const { message, blockCounter, rules, repeatableBlockCounter, repeatableParameters } = this.messageObject;
                this.documentEmail.template = message;
                this.documentEmail.rules = rules;
                this.documentEmail.blockCounter = blockCounter;
                this.documentEmail.repeatableBlockCounter = repeatableBlockCounter;
                this.documentEmail.repeatableParameters = repeatableParameters;
            }
        },
        loadDateFormat(date) {
            const formattedDate = date.split(";");
            let finalDate;
            let day = formattedDate[0];
            let hour = formattedDate[1];
            let min = formattedDate[2];
            if (!/^0*$/.test(day)) {
                day = `${day}d`;
            } else {
                day = "";
            }
            if (!/^0*$/.test(hour)) {
                hour = `${hour}h`;
            } else {
                hour = "";
            }
            if (!/^0*$/.test(min)) {
                min = `${min}m`;
            } else {
                min = "";
            }
            finalDate = (day + hour + min).trim();
            if (this.notification.trigger === "on" && !finalDate) {
                finalDate = "0d";
                this.formatTime = "";
                this.timeframeDisabled = true;
                this.timeframeError = false;
            }
            return finalDate;
        }
    }
};
